import React from "react";

const styles = {
  A: "bg-green-700 text-white",
  B: "bg-green-500 text-white",
  C: "bg-yellow-400 text-black",
  D: "bg-orange-500 text-white",
  F: "bg-red-600 text-white",
  INSUFFICIENT_DATA: "bg-gray-400 text-white",
};

/**
 * Badge de score A/B/C/D/F/INSUFFICIENT_DATA
 * Null-safe, jamais de crash
 */
export default function ScoreBadge({ score, numeric }) {
  const cls = styles[score] || styles.INSUFFICIENT_DATA;
  const displayScore = score || "N/A";

  return (
    <div className={`inline-flex items-center gap-2 px-4 py-2 rounded-full font-semibold text-lg ${cls}`}>
      <span>{displayScore}</span>
      {numeric !== null && numeric !== undefined && (
        <span className="text-sm opacity-90">({numeric.toFixed(1)})</span>
      )}
    </div>
  );
}
